<template>
  <Page title="Edit Warranty Program">
    <Breadcrumbs
      :crumbs="crumbs"
      root-text="Warranty Programs"
      class="mb-3"
      @click="handleCrumbClick"
    />
    <WarrantyProgramForm v-if="currentWarrantyProgram" />
  </Page>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getPathValueAt } from "@/lib/url.js";

import Page from "@/components/Page.vue";
import WarrantyProgramForm from "@/WarrantyPrograms/WarrantyProgramForm.vue";
export default {
  components: {
    Page,
    WarrantyProgramForm
  },
  computed: {
    ...mapState(["currentWarrantyProgram"]),
    crumbs() {
      if (this.currentWarrantyProgram) {
        return [
          {
            id: this.currentWarrantyProgram.id,
            label: this.currentWarrantyProgram.name
          }
        ];
      }
      return [];
    }
  },
  mounted() {
    this.fetchProgram();
  },
  methods: {
    ...mapActions(["fetchWarrantyProgram"]),
    fetchProgram() {
      const id = getPathValueAt(1);
      this.fetchWarrantyProgram(id);
    },
    handleCrumbClick(crumb) {
      if (crumb.id === "root") {
        this.$router.push(this.warrantyProgramIndexPath());
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
